import { createSSRApp, h, DefineComponent } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import { ZiggyVue } from 'ziggy-js';
import { createPinia } from 'pinia';
import DefaultLayout from '@/Layouts/Default.vue';
import {DayJsPlugin} from "@/Plugins/DayJsPlugin";
import * as Sentry from "@sentry/vue";
import 'delayed-scroll-restoration-polyfill';
import Gsap from '@/Plugins/Gsap';
const pinia = createPinia();

createInertiaApp({
    progress: false,
    resolve: async (name) => {
        const pages = import.meta.glob<DefineComponent>('./Pages/**/*.vue');
        let page = await pages[`./Pages/${name}.vue`]();
        (page as any).default.layout = (page as any).default.layout || DefaultLayout;
        return page;
    },
    setup({ el, App, props, plugin }) {
        const app = createSSRApp({ render: () => h(App, props) });

        try {
            Sentry.init({
                app,
                dsn: import.meta.env.VITE_SENTRY_DSN,
                integrations: [
                    Sentry.replayIntegration(),
                ],
                // Session Replay
                replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            });
        } catch (_e) {
            // Do nothing.
        }

            app.use(plugin)
            .use(pinia)
            .use(ZiggyVue)
            .use(DayJsPlugin)
            .use(Gsap)
            .mount(el);
    },
});
